import { createFileRoute } from "@tanstack/react-router";
import { NutzerSeite } from "@/components/NutzerSeite";

/*
 * `/admin/users` — die Benutzerverwaltung.
 *
 * Der Unterstrich in `admin_.users.tsx` löst diese Route aus `admin.tsx`
 * heraus, genau wie bei `admin_.api-keys.tsx`, `admin_.upload.tsx` und
 * `admin_.archiv.tsx`: sie liegt PFADLICH unter `/admin`, aber nicht in dessen
 * Layout. Ohne ihn würde `admin.tsx` zur Layout-Route, ihre Landeseite stünde
 * über jeder Unterseite, und `/admin` bräuchte eine zusätzliche Index-Route.
 * Nachgesehen wird das am Generat (`fullPaths` führt `/admin/users`), nicht
 * geraten.
 *
 * `users` und nicht `nutzer`: so heißt der Pfad im Bestand, so heißt der
 * Endpunkt (`PathAdminNutzer`), und so steht er in der Bereichsliste der
 * Landeseite. Ein Pfad, der anders heißt als der Endpunkt, den er ruft, kostet
 * bei jeder Fehlersuche einen Gedankenschritt.
 *
 * Kein `loader`: die Sicht erfragt Zugang und Daten in EINEM Aufruf und hat
 * außerdem zwei Mutationen mit eigenen Fehlerzuständen. Das gehört in die
 * Komponente, die es anzeigt.
 */
export const Route = createFileRoute("/admin_/users")({
  component: NutzerSeite,
});
